export const formatAnswer = (content: string) => {
  const lines = content.split('\n');
  return lines.map(line => `<p>${line}</p>`).join('');
};
